// Centralized SEO constants.
// The production origin is read from the VITE_SITE_URL environment variable
// and falls back to a safe default so the site still renders correctly in dev.

const rawOrigin =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://cssbuybr.run';

export const SITE_ORIGIN = rawOrigin.replace(/\/+$/, '');

export const SITE_NAME = 'CSSBuy Spreadsheet';

export const SITE_DESCRIPTION =
  'The complete CSSBuy Spreadsheet resource hub. Find products, sellers, QC guides, shipping info, warehouse details, and buying tips for CSSBuy in 2026.';

export const LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

export const DEFAULT_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20sophisticated%20editorial%20flat%20lay%20of%20premium%20fashion%20products%20including%20white%20sneakers%20a%20folded%20beige%20hoodie%20a%20leather%20handbag%20and%20sunglasses%20arranged%20on%20a%20warm%20cream%20marble%20surface%2C%20soft%20natural%20side%20lighting%20with%20gentle%20shadows%2C%20high-end%20e-commerce%20catalog%20photography%20with%20a%20clean%20airy%20minimalist%20composition&width=1600&height=900&seq=hero-bg&orientation=landscape&nocache=true';

export function absoluteUrl(path: string): string {
  if (path === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${path}`;
}